export class CertificateModel {
  certificateId: string;
  certificateName: string;
  expireDate: string;
  image: any;
  companyId: string;
  pdf:any;


  constructor() {
    this.certificateId = "";
    this.certificateName = "";
    this.expireDate = "";
    this.image = "";
    this.companyId = "";
    this.pdf = ""
  }
}